/*
 * Metrics catalog (sections/metrics-catalog.liquid): Cards / List view toggle.
 */
(function () {
  function init(root) {
    if (root.dataset.viewToggleReady) return;
    root.dataset.viewToggleReady = 'true';

    var groups = root.querySelector('.metrics-catalog__groups');
    var buttons = root.querySelectorAll('.metrics-catalog__viewbtn');
    if (!groups || !buttons.length) return;

    function setView(view) {
      groups.setAttribute('data-view', view);
      buttons.forEach(function (button) {
        var isActive = button.getAttribute('data-view') === view;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        setView(button.getAttribute('data-view'));
      });
    });
  }

  document.querySelectorAll('[id^="MetricsCatalog-"]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[id^="MetricsCatalog-"]');
    if (root) init(root);
  });
})();
